/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import ReportFactory from 'lib/report-factory';

const ReportPreview = ({ isVisible, report, close }) => {
	const component =
		report &&
		ReportFactory.create({
			reportId: report.id,
			template: report.template,
			includeEdits: false,
			draggable: false,
			showActions: false,
		});
		
	return (
		<Modal className='my-reports__preview' close={close} isVisible={isVisible} header={false}>
			{component}
		</Modal>
	);
};

export default ReportPreview;
